import { useState } from "react";
import { useIsSuperAdmin } from "@/app/auth";
import { Alert, PageHeader, Tabs } from "@/ui";
import { NotifyEvents } from "./NotifyEvents";
import { NotifySettingsPanel } from "./NotifySettings";
import { NotifyTypes } from "./NotifyTypes";

type Tab = "settings" | "types" | "events";
const TABS: { key: Tab; label: string }[] = [{ key: "settings", label: "设置" }, { key: "types", label: "事件类型" }, { key: "events", label: "发送记录" }];

/** 事件通知（决策 D210，docs/04 第 15 节）：后台操作与系统事件由 cron 投递到一个 webhook。三个页签：设置与测试发送、事件类型开关、发送记录。
 * 只有超级管理员能看（D181）：其他角色从地址栏直接进来时只给说明、不发请求。 */
export function Notify() {
  const allowed = useIsSuperAdmin();
  const [tab, setTab] = useState<Tab>("settings");
  const header = <PageHeader title="事件通知" description="把后台操作与系统事件推送到一个 webhook。先在“设置”配好地址，再在“事件类型”里选要发哪些。" />;
  if (!allowed) return <>{header}<Alert title="只有超级管理员能管理事件通知" /></>;
  return (
    <>
      {header}
      <div className="ax-stack">
        <Tabs items={TABS} value={tab} onChange={setTab} />
        {/* 设置页签始终挂载、切走只隐藏：未保存的草稿不丢 */}
        <div hidden={tab !== "settings"}><NotifySettingsPanel /></div>
        {tab === "types" && <NotifyTypes />}
        {tab === "events" && <NotifyEvents />}
      </div>
    </>
  );
}
